import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GoogleTagsService {

    public getTagManager(containerId: string): string {
        return `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','` + containerId +`');`;
    }

    public getNoscriptTagManager(containerId: string): string {
        return `<iframe src="https://www.googletagmanager.com/ns.html?id=` + containerId +`"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    }

    public getAnaliticsSrc(measurementId: string): string {
        return `https://www.googletagmanager.com/gtag/js?id=` + measurementId;
    }

    public getAnaliticsTag(measurementId: string): string {
        return `window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '` + measurementId + `');`;
    }

    public getFirebaseTag(apiKey: string,
        authDomain: string,
        databaseURL: string,
        projectId: string,
        storageBucket: string,
        messagingSenderId: string,
        appId: string,
        measurementId: string): string {
        return `// Import the functions you need from the SDKs you need
        import { initializeApp } from "https://www.gstatic.com/firebasejs/12.4.0/firebase-app.js";
        import { getAnalytics } from "https://www.gstatic.com/firebasejs/12.4.0/firebase-analytics.js";
        // TODO: Add SDKs for Firebase products that you want to use
        // https://firebase.google.com/docs/web/setup#available-libraries
  
        // Your web app's Firebase configuration
        // For Firebase JS SDK v7.20.0 and later, measurementId is optional
        const firebaseConfig = {
          apiKey: "` + apiKey + `",
          authDomain: "` + authDomain + `",
          projectId: "` + projectId + `",
          storageBucket: "` + storageBucket + `",
          messagingSenderId: "` + messagingSenderId + `",
          appId: "` + appId + `",
          measurementId: "` + measurementId + `"
        };
  
        // Initialize Firebase
        const app = initializeApp(firebaseConfig);
        const analytics = getAnalytics(app);`;
    }
}